export function reviews() {
    function loadMore() {
        const formData  = new FormData();

        document.querySelectorAll('.js-card').forEach($item => {
            formData.append('exclude_ids[]', $item.dataset.id);
        });

        fetch(location.href, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        })
        .then(response => response.json())
        .then(r => {
            const $cards        = document.querySelector('.js-cards');
            const $loadMore     = document.querySelector('.js-loadMore');
            const $firstColumn  = document.querySelector('.js-firstColumn');
            const $secondColumn = document.querySelector('.js-secondColumn');
            const $thirdColumn  = document.querySelector('.js-thirdColumn');
            const $commonColumn  = document.querySelector('.js-commonColumn');

            if (r.status === 'ok') {
                const $div = document.createElement('div');
                      $div.innerHTML = r.render;

                $div.querySelectorAll('.js-card').forEach($item => {
                    if ($commonColumn) {
                        $commonColumn.appendChild($item);
                    } else {
                        // мобилка
                        if ($item.dataset.column == 1) {
                            $firstColumn.appendChild($item);
                        }
                        if ($item.dataset.column == 2) {
                            $secondColumn.appendChild($item);
                        }
                        if ($item.dataset.column == 3) {
                            $thirdColumn.appendChild($item);
                        }
                    }
                });

                // $cards.innerHTML += r.render;

                $loadMore.classList.toggle('is-hidden', r.count <= $loadMore.dataset.limit);
            }
        });
    }

    document.addEventListener('click', function(e) {
        const $item = e.target;

        if ($item.classList.contains('js-loadMore')) {
            return loadMore();
        }
    });
}
